export default class UserInputResult
{
    constructor(pace='standard')
    {
        this.userInputs = []
        this.pace = pace
    }

    setPace(pace='standard')
    {
        this.pace = pace
    }

    isPace(value)
    {
        return this.pace === value
    }

    prefixUserInput(image, group, userInputValue)
    {
        this.userInputs.unshift({
            image: image,
            expectedInput: group,
            userInput: userInputValue
        })
    }

    getResultStructure()
    {
        return {
            context: {
                pace: this.pace,
            },
            userInputs: this.userInputs
        }
    }

    resetResultStructureWith(data)
    {
        this.pace = data ? data.context.pace || 'standard' : 'standard';

        this.userInputs = data ? data.userInputs || [] : [];
    }

    correctUserInputCount()
    {
        return this.userInputs.filter( ui => ui.userInput === ui.expectedInput ).length
    }

    userInputCount()
    {
        return this.userInputs.length
    }
}